{
  "COMPOSE_REDIRECT": {
    "OPENING": "Duke hapur një bisedë të re me {email}…",
    "NO_EMAIL": "Nuk u dha asnjë adresë email-i. Përdorni ?email=name@example.com",
    "CONTACT_ERROR": "Kontakti për {email} nuk mund të gjendej."
  },
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Please select a conversation from left pane",
    "CSAT_REPLY_MESSAGE": "Please rate the conversation",
    "404": "Sorry, we cannot find the conversation. Please try again",
    "SWITCH_VIEW_LAYOUT": "Switch the layout",
    "DASHBOARD_APP_TAB_MESSAGES": "Messages",
    "UNVERIFIED_SESSION": "The identity of this user is not verified",
    "NO_MESSAGE_1": "Uh oh! Looks like there are no messages from customers in your inbox.",
    "NO_MESSAGE_2": " to send a message to your page!",
    "NO_INBOX_1": "Hola! Looks like you haven't added any inboxes yet.",
    "NO_INBOX_2": " to get started",
    "NO_INBOX_AGENT": "Uh Oh! Looks like you are not part of any inbox. Please contact your administrator",
    "SEARCH_MESSAGES": "Search for messages in conversations",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "Përkthim",
    "EMPTY_STATE": {
      "CMD_BAR": "to open command menu",
      "KEYBOARD_SHORTCUTS": "to view keyboard shortcuts"
    },
    "SEARCH": {
      "TITLE": "Search messages",
      "RESULT_TITLE": "Search Results",
      "LOADING_MESSAGE": "Crunching data...",
      "PLACEHOLDER": "Type any text to search messages",
      "NO_MATCHING_RESULTS": "No results found."
    },
    "UNREAD_MESSAGES": "Unread Messages",
    "UNREAD_MESSAGE": "Unread Message",
    "CLICK_HERE": "Click here",
    "LOADING_INBOXES": "Loading inboxes",
    "LOADING_CONVERSATIONS": "Loading Conversations",
    "CANNOT_REPLY": "You cannot reply due to",
    "24_HOURS_WINDOW": "24 hour message window restriction",
    "NOT_ASSIGNED_TO_YOU": "This conversation is not assigned to you. Would you like to assign this conversation to yourself?",
    "ASSIGN_TO_ME": "Assign to me",
    "TWILIO_WHATSAPP_CAN_REPLY": "You can only reply to this conversation using a template message due to",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "24 hour message window restriction",
    "REPLYING_TO": "You are replying to:",
    "REMOVE_SELECTION": "Remove Selection",
    "DOWNLOAD": "Download",
    "UNKNOWN_FILE_TYPE": "Unknown File",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Para dërgimit, kryeni:",
      "EXECUTE": "Kryej",
      "RETRY": "Provo përsëri",
      "CONFIRM": "Të kryhet tani?",
      "CONFIRM_YES": "Po, kryej",
      "CONFIRM_NO": "Anulo",
      "RUNNING": "Në proces…",
      "DONE": "U krye",
      "CLAIM_DELAYED": "do të paraqitet pasi të dorëzohet porosia",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "U krijua një reklamim i RI {reference}, {planned} është i mbyllur — ndryshoni tekstin e draftit",
        "NEW_CLAIM": "U krijua një reklamim i RI {reference} në vend që të përditësohej {planned} — ndryshoni tekstin e draftit",
        "OTHER_CLAIM": "U përditësua reklamimi {reference} në vend të {planned} — ndryshoni tekstin e draftit",
        "EXISTING_CLAIM": "Nuk u krijua reklamim i ri, u përditësua ai ekzistues {reference} — ndryshoni tekstin e draftit",
        "OTHER": "Ndodhi ndryshe nga ç'u parashikua në draft — ndryshoni tekstin e draftit"
      },
      "FAILED": "Dështoi",
      "UNREACHABLE": "Boti nuk është i arritshëm",
      "REQUEST_FAILED": "Veprimi nuk mund të nisej, provoni përsëri.",
      "ACTIONS": {
        "CANCEL_ORDER": "Anuloni porosinë",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Ndryshoni mënyrën e pagesës në pagesë në dorëzim",
        "CREATE_CLAIM": "Paraqitni një reklamim",
        "CREATE_OR_UPDATE_CLAIM": "Paraqitni ose përditësoni një reklamim",
        "EXTEND_ORDER_PICKUP_DATE": "Zgjatni afatin e tërheqjes"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file"
    },
    "UPLOADING_ATTACHMENTS": "Uploading attachments...",
    "REPLIED_TO_STORY": "Replied to your story",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "This message is unsupported. You can view this message on the Facebook Messenger app.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "This message is unsupported. You can view this message on the Instagram app.",
    "SUCCESS_DELETE_MESSAGE": "Message deleted successfully",
    "FAIL_DELETE_MESSSAGE": "Couldn't delete message! Try again",
    "NO_RESPONSE": "No response",
    "RESPONSE": "Response",
    "RATING_TITLE": "Rating",
    "FEEDBACK_TITLE": "Feedback",
    "REPLY_MESSAGE_NOT_FOUND": "Message not available",
    "CARD": {
      "SHOW_LABELS": "Show labels",
      "HIDE_LABELS": "Hide labels"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Resolve",
      "REOPEN_ACTION": "Reopen",
      "OPEN_ACTION": "Open",
      "OPEN": "More",
      "CLOSE": "Close",
      "DETAILS": "details",
      "SNOOZED_UNTIL": "Snoozed until",
      "SNOOZED_UNTIL_TOMORROW": "Snoozed until tomorrow",
      "SNOOZED_UNTIL_NEXT_WEEK": "Snoozed until next week",
      "SNOOZED_UNTIL_NEXT_REPLY": "Snoozed until next reply",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      },
      "MORE": "More actions"
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Mark as pending",
      "SNOOZE_UNTIL": "Snooze",
      "SNOOZE": {
        "TITLE": "Snooze until",
        "NEXT_REPLY": "Next reply",
        "TOMORROW": "Tomorrow",
        "NEXT_WEEK": "Next week"
      },
      "RESOLVE_WITHOUT_CSAT": "Resolve without CSAT"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Snooze until",
      "APPLY": "Snooze",
      "CANCEL": "Cancel"
    },
    "PRIORITY": {
      "TITLE": "Priority",
      "OPTIONS": {
        "NONE": "Asnjë",
        "URGENT": "Urgjente",
        "HIGH": "E lartë",
        "MEDIUM": "Mesatare",
        "LOW": "E ulët"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "None",
        "INPUT_PLACEHOLDER": "Select priority",
        "NO_RESULTS": "No results found",
        "SUCCESSFUL": "Changed priority of conversation id {conversationId} to {priority}",
        "FAILED": "Couldn't change priority. Please try again."
      }
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Hape në skedë të re",
      "COPY_LINK": "Kopjo lidhjen e bisedës",
      "COPY_LINK_SUCCESS": "Lidhja e bisedës u kopjua në kujtesën e fragmenteve",
      "PENDING": "Mark as pending",
      "RESOLVED": "Mark as resolved",
      "MARK_AS_UNREAD": "Mark as unread",
      "MARK_AS_READ": "Mark as read",
      "REOPEN": "Reopen conversation",
      "SNOOZE": {
        "TITLE": "Snooze",
        "NEXT_REPLY": "Until next reply",
        "TOMORROW": "Until tomorrow",
        "NEXT_WEEK": "Until next week"
      },
      "ASSIGN_AGENT": "Assign agent",
      "ASSIGN_LABEL": "Assign label",
      "AGENTS_LOADING": "Loading agents...",
      "ASSIGN_TEAM": "Assign team",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Conversation id {conversationId} assigned to \"{agentName}\"",
          "FAILED": "Couldn't assign agent. Please try again."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Couldn't assign label. Please try again."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Assigned team \"{team}\" to conversation id {conversationId}",
          "FAILED": "Couldn't assign team. Please try again."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Message signature",
      "ENABLE_SIGN_TOOLTIP": "Enable signature",
      "DISABLE_SIGN_TOOLTIP": "Disable signature",
      "MSG_INPUT": "Shift + enter for new line. Start with '/' to select a Canned Response.",
      "PRIVATE_MSG_INPUT": "Shift + enter for new line. This will be visible only to Agents",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Message signature is not configured, please configure it in profile settings.",
      "CLICK_HERE": "Click here to update",
      "WHATSAPP_TEMPLATES": "Whatsapp Templates",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "The 24 hour WhatsApp window has expired. Reply with a template message.",
      "INSERT_SIGNATURE": "Insert signature into editor",
      "SIGNATURE_PREVIEW_IMAGE": "(image signature)"
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Përgjigja juaj duket se është në {draftLanguage}, por kjo bisedë është në {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Përkthe",
      "REPLY": "Reply",
      "PRIVATE_NOTE": "Private Note",
      "SEND": "Send",
      "CREATE": "Add Note",
      "INSERT_READ_MORE": "Read more",
      "DISMISS_REPLY": "Dismiss reply",
      "REPLYING_TO": "Replying to:",
      "TIP_FORMAT_ICON": "Show rich text editor",
      "HEADING_LEVEL": {
        "LABEL": "Stili i tekstit",
        "NORMAL": "Tekst normal",
        "H1": "Titull 1",
        "H2": "Titull 2",
        "H3": "Titull 3"
      },
      "EDITOR": {
        "BOLD": "Trashë",
        "ITALIC": "Të pjerrëta",
        "UNDERLINE": "Nënvizuar",
        "TEXT_COLOR": "Ngjyra e tekstit",
        "BG_COLOR_LABEL": "Ngjyra e sfondit",
        "FONT_SIZE_LABEL": "Madhësia e shkronjave",
        "FONT_SIZE": {
          "XS": "E vogël",
          "SM": "Mesatarisht e vogël",
          "MD": "Parazgjedhje",
          "LG": "E madhe",
          "XL": "Shumë e madhe",
          "XXL": "Gjigante"
        },
        "CODE": "Kod",
        "LINK": "Shto ose hiq lidhjen",
        "CREATE_LINK": "Krijo një lidhje",
        "SAVE_LINK": "Ruaj",
        "CANCEL": "Anulo",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Zhbëj",
        "REDO": "Ribëj",
        "BULLET_LIST": "Listë me shenja",
        "ORDERED_LIST": "Listë e numëruar",
        "BLOCKQUOTE": "Citim",
        "H1": "Titulli 1",
        "H2": "Titulli 2",
        "H3": "Titulli 3",
        "IMAGE_UPLOAD": "Ngarko një imazh",
        "CLEAR_FORMATTING": "Pastro formatimin",
        "COLOR": {
          "RED": "E kuqe",
          "YELLOW": "E verdhë",
          "BLUE": "Blu",
          "ROSE_RED": "E kuqe trëndafili",
          "DEEP_CYAN": "Cian e errët",
          "ORANGE": "Portokalli",
          "PISTACHIO": "Pistashio",
          "PURPLE": "Vjollcë",
          "FUCHSIA": "Fuksia",
          "SILVER": "Argjendi",
          "NAVY": "Blu marine",
          "OLD_PINK": "Rozë e vjetër",
          "AQUA": "Akuamarinë",
          "BROWN": "Kafe",
          "OLIVE": "Ulliri",
          "GOLD": "Ari",
          "BEIGE": "Bezh",
          "WINE": "Bordo",
          "FOREST": "Jeshile pylli",
          "GREEN": "Jeshile",
          "BLUE_GREY": "Blu gri",
          "RUBY_RED": "E kuqe rubini",
          "CHESTNUT_BROWN": "Kafe gështenjë",
          "ASH_GREY": "Gri hiri"
        },
        "BG_COLOR": {
          "RED": "E kuqe",
          "YELLOW": "E verdhë",
          "BLUE": "Blu",
          "ROSE_RED": "E kuqe trëndafili",
          "DEEP_CYAN": "Cian e errët",
          "ORANGE": "Portokalli",
          "PISTACHIO": "Pistashio",
          "PURPLE": "Vjollcë",
          "FUCHSIA": "Fuksia",
          "SILVER": "Argjendi",
          "NAVY": "Blu marine",
          "OLD_PINK": "Rozë e vjetër",
          "AQUA": "Akuamarinë",
          "BROWN": "Kafe",
          "OLIVE": "Ulliri",
          "GOLD": "Ari",
          "BEIGE": "Bezh",
          "WINE": "Bordo",
          "FOREST": "Jeshile pylli",
          "GREEN": "Jeshile",
          "BLUE_GREY": "Blu gri",
          "RUBY_RED": "E kuqe rubini",
          "CHESTNUT_BROWN": "Kafe gështenjë",
          "ASH_GREY": "Gri hiri"
        }
      },
      "TIP_EMOJI_ICON": "Show emoji selector",
      "TIP_ATTACH_ICON": "Attach files",
      "TIP_AUDIORECORDER_ICON": "Record audio",
      "TIP_AUDIORECORDER_PERMISSION": "Allow access to audio",
      "TIP_AUDIORECORDER_ERROR": "Could not open the audio",
      "DRAG_DROP": "Drag and drop here to attach",
      "START_AUDIO_RECORDING": "Start audio recording",
      "STOP_AUDIO_RECORDING": "Stop audio recording",
      "": "",
      "EMAIL_HEAD": {
        "TO": "TO",
        "ADD_BCC": "Add bcc",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "Emails separated by commas",
          "ERROR": "Please enter valid email addresses"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "Emails separated by commas",
          "ERROR": "Please enter valid email addresses"
        },
        "EDIT": "Edit",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Hide",
        "INCLUDE_ORIGINAL_MESSAGE": "Include original message",
        "EDIT_HEADERS": "Edit",
        "HIDE_HEADER_EDITS": "Hide edits",
        "SUBJECT": {
          "LABEL": "SUBJECT",
          "PLACEHOLDER": "Email subject",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Undefined variables",
        "MESSAGE": "You have {undefinedVariablesCount} undefined variables in your message: {undefinedVariables}. Would you like to send the message anyway?",
        "CONFIRM": {
          "YES": "Send",
          "CANCEL": "Cancel"
        }
      },
      "SEND_EMAIL": "Send email",
      "SEND_SMS": "Send SMS",
      "NO_SMS_INBOX": "Shtoni një kuti hyrëse SMS për të dërguar përgjigje SMS.",
      "SEND_CHAT": "Send chat",
      "REPLY_TO_THIS": "Reply to this",
      "TIP_EXPAND_ICON": "Enlarge editor",
      "TIP_COLLAPSE_ICON": "Shrink editor",
      "COPILOT": {
        "Q": "Ask robot for help"
      }
    },
    "VISIBLE_TO_AGENTS": "Private Note: Only visible to you and your team",
    "CHANGE_STATUS": "Conversation status changed",
    "CHANGE_STATUS_FAILED": "Conversation status change failed",
    "CHANGE_AGENT": "Conversation Assignee changed",
    "CHANGE_AGENT_FAILED": "Assignee change failed",
    "ASSIGN_LABEL_SUCCESFUL": "Label assigned successfully",
    "ASSIGN_LABEL_FAILED": "Label assignment failed",
    "CHANGE_TEAM": "Conversation team changed",
    "FILE_SIZE_LIMIT": "File exceeds the {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB attachment limit",
    "MESSAGE_ERROR": "Unable to send this message, please try again later",
    "SENT_BY": "Sent by:",
    "BOT": "Bot",
    "SEND_FAILED": "Couldn't send message! Try again",
    "TRY_AGAIN": "retry",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Select Agent",
      "REMOVE": "Remove",
      "ASSIGN": "Assign"
    },
    "CONTEXT_MENU": {
      "COPY": "Copy",
      "REPLY_TO": "Reply to this message",
      "DELETE": "Delete",
      "CREATE_A_CANNED_RESPONSE": "Add to canned responses",
      "TRANSLATE": "Translate",
      "COPY_PERMALINK": "Copy link to the message",
      "LINK_COPIED": "Message URL copied to the clipboard",
      "DELETE_CONFIRMATION": {
        "TITLE": "Are you sure you want to delete this message?",
        "MESSAGE": "You cannot undo this action",
        "DELETE": "Delete",
        "CANCEL": "Cancel"
      },
      "FORWARD": "Foward",
      "FORWARD_ERROR": "Failed to prepare forwarded message"
    },
    "SIDEBAR": {
      "CONTACT": "Contact",
      "COPILOT": "Copilot"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "Conversation was marked resolved by {userName}",
          "CONTACT_RESOLVED": "Conversation was resolved by {contactName}",
          "OPEN": "Conversation was reopened by {userName}",
          "PENDING": "Conversation was marked as pending by {userName}",
          "SNOOZED": "Conversation was snoozed by {userName}",
          "AUTO_RESOLVED": "Conversation was marked resolved by system due to {duration} days of inactivity",
          "SYSTEM_AUTO_OPEN": "System reopened the conversation due to a new incoming message.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "Conversation was marked resolved by {userName} (without CSAT)",
          "AUTO_RESOLVED_INACTIVE": "Conversation was marked resolved by system due to {duration} hours of inactivity",
          "AUTO_RESOLVED_EMPTY": "Conversation was marked resolved by system due to being empty.",
          "BLOCKED_CONTACT_RESOLVED": "System resolved the conversation because the contact is blocked.",
          "KAUFLAND_TICKET_CLOSED": "Sistemi e zgjidhi bisedën sepse tiketa u mbyll në Kaufland."
        },
        "PRIORITY": {
          "ADDED": "{userName} set the priority to {newPriority}",
          "UPDATED": "{userName} changed the priority from {oldPriority} to {newPriority}",
          "REMOVED": "{userName} removed the priority"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} self-assigned this conversation",
          "ASSIGNED": "Assigned to {assigneeName} by {userName}",
          "REMOVED": "Conversation unassigned by {userName}"
        },
        "TEAM": {
          "ASSIGNED": "Assigned to {teamName} by {userName}",
          "ASSIGNED_WITH_ASSIGNEE": "Assigned to {assigneeName} via {teamName} by {userName}",
          "REMOVED": "Unassigned from {teamName} by {userName}"
        },
        "LABELS": {
          "ADDED": "{userName} added {labels}",
          "REMOVED": "{userName} removed {labels}"
        },
        "SLA": {
          "ADDED": "{userName} added SLA policy {slaName}",
          "REMOVED": "{userName} removed SLA policy {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName} has muted the conversation",
        "UNMUTED": "{userName} has unmuted the conversation",
        "CONTACT_BLOCKED": "{userName} bllokoi kontaktin",
        "CONTACT_UNBLOCKED": "{userName} zhbllokoi kontaktin",
        "AUTO_RESOLUTION_MESSAGE": "Resolving the conversation as it has been inactive for a while. Please start a new conversation if you need further assistance.",
        "DOMAIN_BLOCKED": "{userName} blocked all contacts for a given domain",
        "DOMAIN_UNBLOCKED": "{userName} unblocked all the contacts for a given domain",
        "MOVED": "{userName} moved this conversation from inbox {sourceInboxName} to inbox {targetInboxName}",
        "MOVED_BY_ORDER": "U zhvendos sepse porositë e kontaktit vijnë vetëm nga dyqani {storeName} (porosia e fundit {orderId}), roboti i të cilit përgjigjet në këtë kuti.",
        "MERGED": "{userName} merged conversation #{sourceId} into this conversation",
        "AUTOMATION_RULE_TRIGGERED": "Automation rule \"{ruleName}\" triggered",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Automation rule \"{ruleName}\" disabled automatic priority",
        "AUTOMATION_SKIP_AUTO_LABELING": "Automation rule \"{ruleName}\" disabled automatic labeling",
        "AUTOMATION_STOP_PROCESSING_RULES": "Automation rule \"{ruleName}\" stopped further rule processing",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Sending message action was skipped for this auto-reply message",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "Automatizimi u anashkalua sepse kontakti është i bllokuar",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "Automatizimi \"{ruleName}\" nuk mundi ta zhvendoste këtë bisedë nga kutia hyrëse {sourceInboxName} në kutinë hyrëse {targetInboxName}, sepse kutitë nuk janë të përputhshme.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "Automatizimi \"{ruleName}\" nuk mundi ta zhvendoste këtë bisedë nga kutia hyrëse {sourceInboxName} në kutinë hyrëse {targetInboxName}, sepse kontakti nuk ka adresë email.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "Automatizimi „{ruleName}“ nuk mundi të dërgonte një mesazh: kjo kuti hyrëse telefoni nuk mund të dërgojë SMS, sepse llogaria nuk ka kuti hyrëse SMS. Rregulli u çaktivizua dhe administratorët morën një email.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Automatizimi „{ruleName}“ nuk mundi të dërgonte një mesazh: nga kjo kuti hyrëse nuk mund të dërgohen bashkëngjitje me SMS. Rregulli u çaktivizua dhe administratorët morën një email.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "Makroja „{macroName}“ nuk e dërgoi mesazhin e saj: kjo kuti hyrëse telefoni nuk mund të dërgojë SMS, sepse llogaria nuk ka kuti hyrëse SMS.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Makroja „{macroName}“ nuk e dërgoi mesazhin e saj: nga kjo kuti hyrëse nuk mund të dërgohen bashkëngjitje me SMS.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "Makroja „{macroName}“ nuk e dërgoi mesazhin e saj: kjo bisedë po trajtohet nga boti. Hapeni fillimisht bisedën.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "Makroja „{macroName}“ nuk e dërgoi mesazhin e saj: kjo kuti hyrëse është shënuar për fshirje. Zhvendoseni fillimisht bisedën në një kuti tjetër hyrëse.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "Automatizimi \"{ruleName}\" i dërgoi një email adresës {contactEmail} në një bisedë të re [#{conversationId}]({conversationPath}) në kutinë hyrëse {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "Automatizimi \"{ruleName}\" e nisi këtë bisedë për shkak të bisedës [#{conversationId}]({conversationPath}) në kutinë hyrëse {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "Automatizimi \"{ruleName}\" nuk mundi ta dërgonte mesazhin në një bisedë të re në kutinë hyrëse {inboxName}, sepse kontakti nuk ka adresë email.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "Automatizimi \"{ruleName}\" i dërgoi një SMS numrit {contactPhone} në një bisedë të re [#{conversationId}]({conversationPath}) në kutinë hyrëse {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "Automatizimi \"{ruleName}\" nuk mundi ta dërgonte SMS-in në një bisedë të re në kutinë hyrëse {inboxName}, sepse kontakti nuk ka numër telefoni.",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Agjent",
            "CUSTOMER": "Klient"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "u përgjigj diku tjetër, ra zilja për {duration}",
            "NO_ANSWER": "pa përgjigje, ra zilja për {duration}",
            "REJECTED": "refuzuar pasi ra zilja për {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "U zgjidh automatikisht pas thirrjeve kthyese të pasuksesshme, numri: {count}",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Regjistrimi i thirrjes u fshi nga {name}, {date}"
        }
      }
    },
    "IMAGE_RESIZE": {
      "SMALL": "Small",
      "MEDIUM": "Medium",
      "LARGE": "Large",
      "ORIGINAL": "Original"
    },
    "SHOW_HIDDEN_MESSAGES": "Show hidden messages",
    "TRANSCRIPT": {
      "SHOW": "Show full transcript",
      "HIDE": "Hide full transcript",
      "DOWNLOAD": "Download transcript",
      "COPY": "Copy transcript"
    },
    "INVISIBLE_TO_CUSTOMER": "I padukshëm për klientin",
    "SENT_VIA_EMAIL": "Iu dërgua kontaktit edhe me email ({time})",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "FACEBOOK_CANNOT_REPLY": "If you need to continue this conversation, ",
    "PENDING_WITH_BOT_BANNER": "This conversation is being handled by AI bot. If you want to reply, open the conversation first.",
    "INBOX_DELETE_REQUESTED_BANNER": "Kjo kuti hyrëse është shënuar për fshirje, ndaj përgjigjja e klientit nuk do të mbërrinte kurrë. Për t'u përgjigjur, zhvendoseni bisedën në një kuti tjetër hyrëse.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Ky kontakt ka një bisedë tjetër të hapur #{id}",
      "MULTIPLE": "Ky kontakt ka biseda të tjera të hapura ({count})",
      "OPEN": "Hap",
      "SHOW": "Shfaq"
    },
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won't be able to send messages from this conversation anymore.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Cannot send message because the customer is not online and email continuity is not available.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "The customer is not online. They may not receive messages since email continuity is not available.",
    "OPEN_FILE": "Open",
    "DOWNLOAD_ATTACHMENTS": "Download all",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Download all attachments one by one",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Download all as ZIP",
    "ERROR_DOWNLOADING_FILE": "Error downloading file",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Kërkoji klientit të ndajë numrin e tij të telefonit në WhatsApp",
      "PENDING_ACTION": "Kërkesa për informacion kontakti është në pritje",
      "STATES": {
        "PENDING": "Në pritje të informacionit të kontaktit",
        "SHARED": "Numri i telefonit u nda",
        "IDENTITY_CONFLICT": "Numri i telefonit ka nevojë për shqyrtim"
      }
    },
    "SLA": {
      "BREACHED": "breached"
    },
    "IMAGE_UPLOAD_ERROR": "Unable to upload image, please try again",
    "DRAFT": {
      "FILE_TOO_LARGE": "File '{fileName}' ({fileSize}) is too large for draft storage and will be skipped",
      "ATTACHMENT_SERIALIZATION_FAILED": "Failed to serialize attachment for draft storage",
      "STORAGE_QUOTA_EXCEEDED": "Storage quota exceeded. Draft saved without attachments",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Failed to save draft even without attachments",
      "SAVE_FAILED": "Failed to save conversation draft"
    },
    "COMMENT_TREE": {
      "TITLE": "Comment thread",
      "EMPTY": "No comments to display",
      "VIEW_TREE": "View comment thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Send conversation transcript",
    "DESC": "Send a copy of the conversation transcript to the specified email address",
    "SUBMIT": "Submit",
    "CANCEL": "Cancel",
    "SEND_EMAIL_SUCCESS": "The chat transcript was sent successfully",
    "SEND_EMAIL_ERROR": "There was an error, please try again",
    "FORM": {
      "SEND_TO_CONTACT": "Send the transcript to the customer",
      "SEND_TO_AGENT": "Send the transcript to the assigned agent",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Send the transcript to another email address",
      "EMAIL": {
        "PLACEHOLDER": "Enter an email address",
        "ERROR": "Please enter a valid email address"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Hey 👋, Welcome to {installationName}!",
    "DESCRIPTION": "Thanks for signing up. We want you to get the most out of {installationName}. Here are a few things you can do in {installationName} to make the experience delightful.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Read our latest updates",
    "ALL_CONVERSATION": {
      "TITLE": "All your conversations in one place",
      "DESCRIPTION": "View all the conversations from your customers in one single dashboard. You can filter the conversations by the incoming channel, label and status.",
      "NEW_LINK": "Click here to create an inbox"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Invite your team members",
      "DESCRIPTION": "Since you are getting ready to talk to your customer, bring in your teammates to assist you. You can invite your teammates by adding their email addresses to the agent list.",
      "NEW_LINK": "Click here to invite a team member"
    },
    "LABELS": {
      "TITLE": "Organize conversations with labels",
      "DESCRIPTION": "Labels provide an easier way to categorize your conversation. Create some labels like #support-enquiry, #billing-question etc., so that you can use them in a conversation later.",
      "NEW_LINK": "Click here to create tags"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Assigned Agent",
    "SELF_ASSIGN": "Assign to me",
    "TEAM_LABEL": "Assigned Team",
    "SELECT": {
      "PLACEHOLDER": "None"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Custom Data",
      "CONTACT_DETAILS": "Contact Details",
      "CONVERSATION_ACTIONS": "Conversation Actions",
      "CONVERSATION_LABELS": "Conversation Labels",
      "CONVERSATION_INFO": "Conversation Information",
      "CONTACT_ATTRIBUTES": "Contact Attributes",
      "PREVIOUS_CONVERSATION": "Previous Conversations",
      "MACROS": "Macros",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "ORDER_HISTORY": "Order History",
      "RETINO_TICKETS": "Retino Tickets"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Pending",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Create attribute",
    "NO_RECORDS_FOUND": "No attributes found",
    "UPDATE": {
      "SUCCESS": "Attribute updated successfully",
      "ERROR": "Unable to update attribute. Please try again later"
    },
    "ADD": {
      "TITLE": "Add",
      "SUCCESS": "Attribute added successfully",
      "ERROR": "Unable to add attribute. Please try again later"
    },
    "DELETE": {
      "SUCCESS": "Attribute deleted successfully",
      "ERROR": "Unable to delete attribute. Please try again later"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Add attributes",
      "PLACEHOLDER": "Search attributes",
      "NO_RESULT": "No attributes found"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "From",
    "TO": "To",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Subject"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Participating",
    "SIDEBAR_TITLE": "Conversation participants",
    "NO_RECORDS_FOUND": "No results found",
    "ADD_PARTICIPANTS": "Select participants",
    "REMANING_PARTICIPANTS_TEXT": "+{count} others",
    "REMANING_PARTICIPANT_TEXT": "+{count} other",
    "TOTAL_PARTICIPANTS_TEXT": "{count} people are participating.",
    "TOTAL_PARTICIPANT_TEXT": "{count} person is participating.",
    "NO_PARTICIPANTS_TEXT": "No one is participating!.",
    "WATCH_CONVERSATION": "Join conversation",
    "YOU_ARE_WATCHING": "You are participating",
    "API": {
      "ERROR_MESSAGE": "Could not update, try again!",
      "SUCCESS_MESSAGE": "Participants updated!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "View translated content",
    "DESC": "You can view the translated content in each langauge.",
    "ORIGINAL_CONTENT": "Original Content",
    "TRANSLATED_CONTENT": "Translated Content",
    "NO_TRANSLATIONS_AVAILABLE": "No translations are available for this content"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing",
    "IMAGE_ALT": "Someone is typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "No data found",
    "LOAD_ERROR": "Unable to load data. Please try again later."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Load more",
    "NO_RECORDS_FOUND": "No tickets found",
    "LOAD_ERROR": "Unable to load tickets from {hookName}. Please try again later.",
    "NOT_SEARCHABLE": "Contact email is not set.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Loading...",
    "NO_ORDERS": "No orders found",
    "NOT_AVAILABLE": "Customer data not available",
    "EXPAND": "Open customer profile",
    "MORE_ITEMS": "+ {count} items",
    "EXPEDITION_STATUS": "Expedition status",
    "OPEN_DETAIL": "open detail",
    "COPY_ORDER_ID": "Numri i porosisë",
    "EXTERNAL_ID": "ID i jashtëm",
    "PAYMENT_TYPE": "Mënyra e pagesës",
    "PAYMENT_DATE": "Data e pagesës",
    "DELIVERY_PROVIDER": "Transportuesi",
    "EXPECTED_DATE_OF_DELIVERY": "Dorëzimi i pritshëm",
    "DATE_OF_DELIVERY": "Dorëzuar më",
    "EXPEDITION_DATE": "Data e dërgimit",
    "INTERNAL_NOTE": "Shënim i dyqanit",
    "PACKAGE_NUMBER": "Pako"
  },
  "READING": {
    "ONE": "{user} is reading this ticket",
    "TWO": "{user} and {secondUser} are reading this ticket",
    "MULTIPLE": "{user} and {count} others are reading this ticket"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Move Conversation",
    "DESCRIPTION": "Move this conversation to a different email inbox.",
    "SOURCE": {
      "TITLE": "Conversation",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Destination Inbox",
      "PLACEHOLDER": "Select an email inbox",
      "NO_RESULTS": "No other email inboxes available",
      "ERROR": "Please select a destination inbox"
    },
    "SUBMIT": "Move Conversation",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation moved successfully",
    "ERROR_MESSAGE": "Could not move conversation. Please try again."
  },
  "MERGE": {
    "TITLE": "Merge Conversations",
    "DESCRIPTION": "Merge this conversation with another conversation. All messages from this conversation will be moved to the target conversation, and this conversation will be deleted.",
    "SOURCE": {
      "TITLE": "Source Conversation (will be deleted)",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Target Conversation",
      "PLACEHOLDER": "Type conversation ID to search (e.g., 123)",
      "HELP": "Enter the conversation ID to merge all messages into.",
      "ERROR": "Please select a target conversation"
    },
    "WARNING": "Warning: This action cannot be undone. All messages will be moved to the target conversation and this conversation will be permanently deleted.",
    "SUBMIT": "Merge Conversations",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation merged successfully",
    "ERROR_MESSAGE": "Could not merge conversations. Please check the target conversation and try again.",
    "SEARCH": {
      "NO_RESULTS": "No conversation found with this ID",
      "ERROR_MESSAGE": "Could not search conversations. Please try again."
    },
    "CONFIRM": {
      "TITLE": "Confirm Merge",
      "DESCRIPTION": "Are you sure you want to merge this conversation? This action cannot be undone.",
      "YES": "Yes, Merge",
      "CANCEL": "Cancel"
    }
  }
}
